import * as Sentry from '@sentry/react';

/**
 * Rejestracja service workera (PWA: offline, instalacja, aktualizacje) — zamiast skryptu
 * `registerSW.js` wstrzykiwanego przez `vite-plugin-pwa` (`injectRegister: false` w
 * `vite.config.ts`). Robi dokładnie to samo co on — rejestracja po `load`, bez przeładowania
 * strony przy aktualizacji (moduł `virtual:pwa-register` w trybie `autoUpdate` przeładowałby
 * ją, gubiąc np. ułożenie floty w trakcie rozstawiania) — plus obsługę odrzucenia.
 *
 * Odrzucenie leciało wcześniej do Sentry jako nieobsłużone `Error: Rejected` (SEA-WARS-WEB-2,
 * Android). Teraz to opisane ostrzeżenie z informacją, czy stronę kontroluje już STARY
 * service worker — wtedy urządzenie może utknąć na starej wersji aplikacji, bo nowy nie
 * ma jak się zarejestrować (wersję widać w stopce, patrz `App.tsx`).
 */
export function registerServiceWorker(): void {
  // W dev `sw.js` nie istnieje (PWA budowane tylko produkcyjnie) — rejestracja z góry skazana na 404.
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error: unknown) => {
      const staleController = navigator.serviceWorker.controller !== null;
      // Wiadomość, nie wyjątek: błąd pochodzi zwykle z kodu wstrzykniętego przez urządzenie
      // (stos bez naszych plików), a zdarzenie bez stosu nie odpada na filtrze `allowUrls`.
      Sentry.captureMessage('Rejestracja service workera odrzucona', {
        level: 'warning',
        fingerprint: ['service-worker-register-rejected'],
        tags: { 'sw.stale_controller': staleController ? 'tak' : 'nie' },
        extra: {
          error: error instanceof Error ? `${error.name}: ${error.message}` : String(error),
        },
      });
    });
  });
}
